// based on rc-checkbox 2.1.6
export { default } from './src/';


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-checkbox/index.js
// module id = null
// module chunks = 